import { render, staticRenderFns } from "./InputLang.vue?vue&type=template&id=6e3bfd76&"
import script from "./InputLang.vue?vue&type=script&lang=js&"
export * from "./InputLang.vue?vue&type=script&lang=js&"
import style0 from "./InputLang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports